import { render } from "./editCategory.vue?vue&type=template&id=716890cf&scoped=true"
import script from "./editCategory.vue?vue&type=script&lang=js"
export * from "./editCategory.vue?vue&type=script&lang=js"

import "./editCategory.vue?vue&type=style&index=0&id=716890cf&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716890cf"],['__file',"src/views/brand/components/editCategory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "716890cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('716890cf', __exports__)) {
    console.log('reload')
    api.reload('716890cf', __exports__)
  }
  
  module.hot.accept("./editCategory.vue?vue&type=template&id=716890cf&scoped=true", () => {
    console.log('re-render')
    api.rerender('716890cf', render)
  })

}


export default __exports__